<template>
<b-modal
    v-model="show"
    centered
    hide-footer
    hide-header
    size="xl"
    id="modal-sign-in"
    class="modal-sign-in p-0"
    scrollable
  >
    <button class="button-close position-absolute close" @click="openModalSignIn()">×</button>
    <div class="row m-0 mb-md-1">
      <b-form class="form col-12 col-lg-6 p-3 p-md-5" @submit.prevent="onSubmit" autocomplete="off">
        <h5 class="mb-3 text-muted">Não tem cadastro na Tipa? Crie sua conta</h5>
        <b-form-group label="Email">
            <b-form-input
              v-model="form.email"
              type="email"
              autocomplete="email"
              maxlength="120"
              required
            />
          </b-form-group>

          <b-form-group label="Seu nome">
            <b-form-input
              v-model="form.name"
              type="text"
              autocomplete="name"
              maxlength="40"
              required
            />

              <small class="form-text">
                Nunca será exibido em suas donates
              </small>
          </b-form-group>

          <b-form-group label="CPF/CNPJ" v-if="false">
            <b-form-input
              v-model="form.document"
              type="text"
              autocomplete="document"
              maxlength="14"
              placeholder="sem pontos, apenas números"
            />
          </b-form-group>

          <b-form-group label="Whatsapp">
            <b-form-input
              v-model="form.phone"
              type="tel"
              autocomplete="phone"
              required
              maxlength="11"
              placeholder="DDD + Telefone, apenas números"
            />
          </b-form-group>

          <b-form-group label="Senha">
            <b-form-input
              v-model="form.password"
              type="password"
              autocomplete="password"
              required
            />
          </b-form-group>

          <b-form-group label="Confirme sua senha">
            <b-form-input
              v-model="form.password_confirmation"
              type="password"
              autocomplete="password"
              maxlength="120"
              required
            />
          </b-form-group>

          <b-form-group label="CPF/CNPJ">
            <b-form-input
              v-model="form.document"
              autocomplete="document"
              maxlength="14"
              type="text"
              placeholder="sem pontos ou traços, apenas números"
              required
            />
          </b-form-group>

          <b-btn variant="primary" type="submit">
            Criar conta
          </b-btn>

        <hr>

        <div class="mb-4">
          <h5 class="m-0 mb-1 text-muted">Já é cadastrado? Acesse sua conta</h5>
          <!-- <p class="m-0 text-muted">venha e faça parte agora - é rapidinho e grátis 🧡</p> -->
        </div>
        <b-btn text @click.stop.prevent="openModalSignIn()">Entrar</b-btn>
      </b-form>

      <div class="col-12 col-lg-6 p-3 p-md-5" style="background: rgba(125, 125, 125, 0.07)">
        <h5 class="mb-3 text-muted">Com sua conta na Tipa</h5>

        <h6>Você que é Apoiador:</h6>

        <ul class="list-style mt-2 px-4">
          <li class="list-item">
            <p class="mb-1">Apoie com valores mais altos</p>
          </li>
          <li class="list-item">
            <p class="mb-1">Conecte com seus criadores favoritos</p>
          </li>
          <li class="list-item">
            <p class="mb-1">Acesso ao histórico de doações</p>
          </li>
          <li class="list-item">
            <p class="mb-1">Integração com comunidades via discord</p>
          </li>
        </ul>

        <h6>Você que é Criador:</h6>

        <ul class="list-style mt-2 px-4">
          <li class="list-item">
            <p class="mb-1">Receba apoio por Pix</p>
          </li>
          <li class="list-item">
            <p class="mb-1">Monetize e aumente sua base de fãs</p>
          </li>
          <li class="list-item">
            <p class="mb-1">Ganhe mais do que você ganha hoje - a tipa tem a menor taxa do mercado</p>
          </li>
          <li class="list-item">
            <p class="mb-1">Novos recursos todas as semanas</p>
          </li>
        </ul>
      </div>
    </div>
  </b-modal>
</template>

<script>
import UserService from '@/services/user.service.js'

export default {
  name: 'ModalSignUp',
  data () {
    return {
      form: {
        email: '',
        name: '',
        document: '',
        phone: '',
        password: '',
        password_confirmation: ''
      }
    }
  },
  computed: {
    show: {
      cache: false,
      get: function () {
        return this.$store.state.modal.show === 'modal-sign-up'
      },
      set: function () {
        this.$store.commit('modal/closeModal')
      }
    }
  },
  mounted () {
  },
  methods: {
    async onSubmit () {
      try {
        this.form.email = this.form.email.toLowerCase()

        const response = await UserService.create({
          user: this.form
        })

        this.$store.dispatch('user/login', response)

        this.$toasted.success('Bem vindo! Te enviamos um email, confira sua caixa de entrada. Caso queira receber donates, clique em Minha conta.')

        this.show = false
      } catch (error) {
        if (error.errors) {
          error.errors.email && this.$toasted.error('E-mail ' + error.errors.email[0])
          error.errors.name && this.$toasted.error('Nome ' + error.errors.document[0])
          error.errors.document && this.$toasted.error('CPF ' + error.errors.document[0])
          error.errors.phone && this.$toasted.error('Whatsapp ' + error.errors.phone[0])
          error.errors.password && this.$toasted.error('Senha ' + error.errors.password[0])
          error.errors.password_confirmation && this.$toasted.error('Confirmação de senha ' + error.errors.password_confirmation[0])
        }
      }
    },
    openModalSignIn () {
      this.$store.commit('modal/showModal', 'modal-sign-in')
    }
  }
}
</script>

<style lang="scss">
  .card-buttons {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

  }

  #modal-sign-up {
    padding-left: 0px !important;
    .button-close {
      z-index: 999;
      position: absolute;
      right: 10px;
      top: 10px;
    }
    h5 {
      font-weight: 400
    }

    // h5 {
    //   font-weight: 500;
    // }
    .modal-header {
      border-bottom: none;
    }
    .modal-body {
      overflow-y: scroll;
      padding: 0;
    }

    .modal-body::-webkit-scrollbar {
      display: none;
    }

    .modal-content {
      border: none;
    }
  }
</style>
